export default "__VITE_ASSET__D0KFQ55j__"